import type { ComponentSchema } from '../../../../../schema-types'
import { SECTION_STYLE_FIELDS } from './_fields'

/** Deals band: countdown boxes, category chips and the most discounted products, with an optional side banner; hidden after it ends. */
export const schema: ComponentSchema = {
  type: 'flash-sale',
  label: 'Flash sale',
  description: 'A grey band with countdown boxes, category chips and the most discounted products, and an optional side banner. Hidden after it ends.',
  supportedPages: ['home'],
  variants: [{ id: 'v1', label: 'Countdown row' }],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string', default: 'Flash sale' },
    { key: 'endDate', label: 'Ends at (ISO date)', type: 'string', placeholder: '2026-12-31T23:59:59', help: 'Leave empty to hide the countdown.' },
    { key: 'sideImage', label: 'Side banner picture', type: 'image', help: 'Tall picture beside the deals (desktop). Optional.' },
    { key: 'sideLink', label: 'Side banner link', type: 'string', placeholder: '/shop' },
    ...SECTION_STYLE_FIELDS,
  ],
}
